/* istanbul ignore file */
import { styled } from '@mui/material/styles';
import { MobileDatePicker } from '@mui/x-date-pickers';

import { px, rem, Theme } from '../../../theme';

export const StyledDateInputContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: ${theme.tggSpacing([0, rem(2)], [0, 5])};
        border-style: solid;
        border-width: ${theme.tggSpacing(rem(0.1), 0.25)};
        border-radius: ${theme.tggSpacing(rem(2.5), 6.25)};
    `}
`;

export const StyledDateInput = styled(MobileDatePicker)`
    ${({ theme }: { theme: Theme }) => theme.typography.text_16};
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(rem(3), 7.5)};

        fieldset {
            border-style: solid;
            border-width: ${theme.tggSpacing(rem(0.1), 0.25)};
            border-radius: ${theme.tggSpacing(rem(2.5), 6.25)};
        }

        input {
            padding:  ${theme.tggSpacing(rem(1.5), 3.75)};
        }

        svg,
        input,
        fieldset {
            cursor: pointer;
        }
	`}
`;

export const StyledHelperText = styled('span')`
    ${({ theme }: { theme: Theme }) => theme.typography.text_12_lh_18}
`;

export const StyledDialogContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        .MuiDialog-paper {
            border-radius: ${theme.tggSpacing(rem(1.6), 6)};
        }

        .MuiPickersToolbar-penIconButton {
            display: none;
        } 

        .MuiPickersArrowSwitcher-button {
            color: ${theme.palette.common.blue};
        }

        .MuiPickersArrowSwitcher-button:last-child {
            margin-left: ${theme.tggSpacing(rem(2), 5)};
        }

        .MuiPickersArrowSwitcher-button.Mui-disabled {
            color: ${theme.palette.common.blue};
            opacity: 0.38;
        }

        .MuiPickersDay-root.MuiPickersDay-today {
            border: ${theme.tggSpacing(px(1), 0.25)} solid
                ${theme.palette.common.blue};
        }

        .MuiPickersDay-root.Mui-disabled {
            color: ${theme.palette.common.blue};
            opacity: 0.38;
        }

        .MuiPickersDay-root.Mui-selected {
            color: ${theme.palette.common.white};
        }

        .MuiPickersToolbar-root {
            padding: ${theme.tggSpacing([rem(2), rem(2), 0], [5, 5, 0])};
        }
        
        .MuiButton-root:first-of-type {
            color: ${theme.palette.common.blue};
        }

        .MuiButton-root:last-of-type {
            color: ${theme.palette.common.white};
            background-color: ${theme.palette.primary.main};
        }

        .MuiButton-root:first-of-type:focus,
        .MuiButton-root:first-of-type:hover {
            outline: ${theme.tggSpacing(rem(0.25), 0.625)}
                solid ${theme.palette.common.blue};
            outline-offset: ${theme.tggSpacing(rem(0.25), 0.625)};
        }

        .MuiButton-root:last-of-type:focus {
            outline: ${theme.tggSpacing(rem(0.25), 0.625)}
                solid ${theme.palette.primary.dark};
            outline-offset: ${theme.tggSpacing(rem(0.25), 0.625)};
        }

        .MuiButton-root:last-of-type:hover {
            background-color: ${theme.palette.primary.dark};
        }
	`}

    .MuiTypography-overline {
        ${({ theme }: { theme: Theme }) => theme.typography.text_16_lh_24};
        ${({ theme }: { theme: Theme }) => `
            color: ${theme.palette.common.blue};
            text-transform: initial;
	    `}
    }

    .MuiDatePickerToolbar-title {
        ${({ theme }: { theme: Theme }) =>
            theme.typography.text_36_lh_40_letter_spacing_negative_0_005};
        ${({ theme }: { theme: Theme }) => `
            margin-top: ${theme.tggSpacing(rem(0.5), 1.25)};
	    `}
    }

    .MuiPickersCalendarHeader-label {
        ${({ theme }: { theme: Theme }) => theme.typography.h5};

        cursor: text;
    }

    .MuiDayPicker-weekDayLabel {
        ${({ theme }: { theme: Theme }) => theme.typography.text_14};
        opacity: 0.38;
    }

    .MuiPickersDay-root {
        ${({ theme }: { theme: Theme }) => theme.typography.text_14};
    }

    .MuiDialogActions-root {
        .MuiButton-root {
            ${({ theme }: { theme: Theme }) => theme.typography.h5};
            ${({ theme }: { theme: Theme }) => `
                display: inline-block;
                min-width: auto;
                padding: ${theme.tggSpacing([rem(0.4), rem(1.6), 0], [1, 4, 0])};
                

                text-transform: lowercase;
                border-radius: ${theme.tggSpacing(rem(36), 90)};
	        `}
        }
    }
`;
